"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SERVER_BASE_URL = 'https://apps.wix.com/events-server';
